import React, { ChangeEvent } from "react";

type ZipcodeFieldProps = {
  label: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  inputAddressData?: (zipcode: string) => void;
}

type StateFieldProps = {
  label: string;
  value: string | undefined;
  states: {id: string, name: string}[] | [];
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
}

type AddressFieldProps = {
  label: string;
  placeholder: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

type AddressData = {
  zipcode: {
    label: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  },
  stateId: {
    label: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  },
  address1: {
    label: string;
    placeholder: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  },
  address2: {
    label: string;
    placeholder: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  },
}

type CheckboxData = {
  label: string;
  defaultChecked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type AddressFieldBoxProps = {
  label: string;
  required?: boolean;
  states: {id: string, name: string}[] | [];
  addressData: AddressData;
  inputAddressData?: (zipcode: string) => void;
  checkboxData?: CheckboxData;
}

export const ZipcodeField: React.FC<ZipcodeFieldProps> = ({ label, value, onChange, inputAddressData }) => (
  <li className="list-input__item">
    <span className="p-country-name" style={{display: 'none'}}>Japan</span>
    <span>{label}</span>
    <div className={`list-input__ct ${ onChange ? "contact-box__flex" : ""}`}>
      {onChange && inputAddressData ?
        <>
          <input type="text" placeholder="1021111" className="input input--pw p-postal-code" size={8} maxLength={8} value={value} onChange={onChange} />
          <div className="contact-box__btn" onClick={() => value && inputAddressData(value)}>住所自動入力</div>
        </>
      :
        <p className="contact-box__desc">{value}</p>
      }
    </div>
  </li>
);

export const StateField: React.FC<StateFieldProps> = ({ label, value, onChange, states }) => (
  <li className="list-input__item">
    <span>{label}</span>
    <div className="list-input__ct">
      {onChange ?
      <>
        <div className="select-custom">
          <select value={value} onChange={onChange} className="p-region-id">
            <option value="">--</option>
            {states && states.map(option => (
              <option key={option.id} value={option.id}>{option.name}</option>
            ))}
          </select>
        </div>
      </>
      :  
        <p className="contact-box__desc">
          {states && (() => {
            const state = states.find((option) => option.id.toString() === value);
            return state ? state.name : '';
          })()}
        </p>
      }
    </div>
  </li>
);

export const AddressField: React.FC<AddressFieldProps> = ({ label, placeholder, value, onChange }) => (
  <li className="list-input__item">
    <span>{label}</span>
    <div className="list-input__ct">
      {onChange ? <input type="text" placeholder={placeholder} value={value} onChange={onChange} className="input" /> : <p className="contact-box__desc">{value}</p> }
    </div>
  </li>

);

export const AddressFieldBox: React.FC<AddressFieldBoxProps> = ({
  label,
  addressData,
  required = false,
  states,
  inputAddressData,
  checkboxData,
}) => {

  const showAddressFields = checkboxData ? !checkboxData.defaultChecked : true;

  return (
    <div className="contact-box__item contact-box__item--start">
      <label className="contact-box__ttl">
        <span>{label}</span>
        { required && <small>必須</small> }
      </label>

      <div className="contact-box__ct">
        {checkboxData && (
          <label className="checkbox-item">
            <input
              type="checkbox"
              defaultChecked={checkboxData.defaultChecked}
              onChange={checkboxData.onChange}
              id="fruitCheckbox"
            />
            <span>{checkboxData.label}</span>
          </label>
        )}
        {showAddressFields && (
          <div>
            <ul className={`list-input ${checkboxData ? "mtpc-10 mtsp-10" : ""}`}>
              <ZipcodeField
                label={addressData.zipcode.label}
                value={addressData.zipcode?.value}
                onChange={addressData.zipcode.onChange}
                inputAddressData={inputAddressData}
              />
              <StateField
                label={addressData.stateId.label}
                value={addressData.stateId?.value}
                onChange={addressData.stateId.onChange}
                states={states}
              />
              <AddressField
                label={addressData.address1.label}
                placeholder={addressData.address1.placeholder}
                value={addressData.address1?.value}
                onChange={addressData.address1.onChange}
              />
              <AddressField
                label={addressData.address2.label}
                placeholder={addressData.address2.placeholder}
                value={addressData.address2?.value}
                onChange={addressData.address2.onChange}
              />
            </ul>
          </div>
        )}
      </div>
    </div>
  )
};
